import React, { useEffect, useState, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useForm } from 'react-hook-form';
import RoutesApp from '../../routes';
import dayjs from 'dayjs';

//Servicios

//Componentes
import Spinner from '../../components/spinner/Spinner';
import DJMVList from './DJMVList';

//Estilos
import right_arrow from '../../assets/imgs/next.png';
import pencil from '../../assets/imgs/edit.png';

function DJTMListContainer() {
    const { token, settings, user, masters, viniedos } = useGlobalContext();
    const { register, handleSubmit, watch, setError, formState } = useForm({
        defaultValues: { myViniedo: 0 },
    });
    const Navigate = useNavigate();

    const [loader, setLoader] = useState(false);
    const [DJMVListData, setDJMVListData] = useState([]);

    const EnableBtn = parseInt(watch('myViniedo'));

    useEffect(() => {
        // const getMyDJMV = async () => {
        //     try {
        //         setLoader(true);
        //         const myDJMVs = await DJMVService.all({
        //             token,
        //             usuarioId: user.id,
        //             // serie: parseInt(dayjs(new Date()).format('YYYY')),
        //         });
        //         if (myDJMVs) {
        //             setDJMVListData(myDJMVs.data);
        //             setTableData(buildTableData(myDJMVs.data));
        //         }
        //         setLoader(false);
        //     } catch (err) {
        //         setLoader(false);
        //     }
        // };
        // if (user.tipo !== 3) getMyDJMV();
    }, []);

    /**Funcion que crea el objeto para pasarle al componente tabla y listar las DJCPs*/
    const buildTableData = (
        data = [
            {
                id: 1,
                viniedo: '',
                fecha: '',
                fecha_cierre: '',
                timbre: '',
                habilitada: '',
                total_kilos: '',
                cerrada: '',
            },
        ]
    ) => {
        return {
            title: 'Declaraciones de Modificación de Viñedo',
            headers: [
                'ID',
                'Viñedo',
                'Fecha',
                'Timbre',
                'Habilitada',
                'Kilos Totales',
                'Cerrada',
                ' ',
            ],
            pagination: 10,
            data: data?.map((dj) => {
                return {
                    id: `${dj.serie}-P-${dj.numero}`,
                    viniedo: dj.viniedo,
                    fecha: dayjs(dj.fecha).format('DD-MM-YYYY'),
                    timbre: dj.timbre ? 'PAGO' : 'NO PAGO',
                    habilitada: masters.HabilitationTypes?.find(
                        (ht) => ht.id === dj.habilitada
                    )?.nombre.replace('_', ' '),
                    kilosTotales: dj.total_Kilos,
                    cerrada: !dj.fecha_cierre ? 'NO' : dj.fecha_cierre,
                    icons: (
                        <div>
                            <Link
                                to={
                                    RoutesApp.Declaraciones
                                        .modificacionViniedo + dj.id
                                }
                                className="table-icon_container"
                            >
                                <img
                                    className="table-icon"
                                    src={right_arrow}
                                    title="Visualizar"
                                    alt="Visualizar"
                                />
                            </Link>
                            <Link
                                to={
                                    RoutesApp.Declaraciones
                                        .nuevaModificacionViniedo + dj.id
                                }
                                className="table-icon_container"
                            >
                                <img
                                    className="table-icon"
                                    src={pencil}
                                    title="Editar"
                                    alt="Editar"
                                />
                            </Link>
                        </div>
                    ),
                };
            }),
        };
    };

    const [tableData, setTableData] = useState(buildTableData());

    const newDJMV = async (data) => {
        try {
            setLoader(true);

            // const newDJMV = await DJMVService.create({
            //     token,
            //     viniedoId: data.myViniedo,
            // });

            // if (newDJMV) {
            //     Navigate(
            // RoutesApp.Declaraciones.nuevaModificacionViniedo +
            //             newDJMV.data.cabecera.id
            //     );
            // }

            setLoader(false);
        } catch (err) {
            setLoader(false);
            return err;
        }
    };

    return loader ? (
        <Spinner />
    ) : (
        <DJMVList
            functions={{
                register,
                handleSubmit,
                watch,
                setError,
                formState,
                newDJMV,
            }}
            states={{
                DJMVListData,
                tableData,
                viniedos,
                settings,
                EnableBtn,
            }}
        />
    );
}

export default DJTMListContainer;
